import { useReducer } from 'react';
import { AxiosError, AxiosResponse } from 'axios';

export type ServiceState<TResponse> = {
  isFetching: boolean;
  error?: AxiosError;
  response: any | AxiosResponse<TResponse>;
  lastFetchAttempt: Date | null;
};

export type Action<TResponse> = {
  type: 'START' | 'ERROR' | 'SUCCESS' | 'RESET';
  error?: any;
  response?: AxiosResponse<TResponse>;
};

export const initiaFetchState = {
  isFetching: false,
  error: null as any,
  response: null as any,
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  lastFetchAttempt: null as Date,
};

export function reducer<TResponse>(
  state: ServiceState<TResponse>,
  action: Action<TResponse>,
) {
  const reducers = {
    START: (
      state: ServiceState<TResponse>,
      _action: Action<TResponse>,
    ): ServiceState<TResponse> => ({
      ...state,
      isFetching: true,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      error: null,
      response: null,
    }),
    ERROR: (
      _state: ServiceState<TResponse>,
      action: Action<TResponse>,
    ): ServiceState<TResponse> => ({
      isFetching: false,
      error: action.error,
      response: action.response,
      lastFetchAttempt: new Date(),
    }),
    SUCCESS: (
      _state: ServiceState<TResponse>,
      action: Action<TResponse>,
    ): ServiceState<TResponse> => ({
      response: action.response,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      error: null,
      isFetching: false,
      lastFetchAttempt: new Date(),
    }),
    RESET: (
      _state: ServiceState<TResponse>,
      _action: Action<TResponse>,
    ): ServiceState<TResponse> => initiaFetchState as ServiceState<TResponse>,
  };
  return reducers[action.type] ? reducers[action.type](state, action) : state;
}

export const useServiceReducer = <TResponse>() =>
  useReducer(reducer, initiaFetchState as ServiceState<TResponse>);
